import { ValidationObserver, ValidationProvider } from "vee-validate";
import * as firebase from "firebase";
import {getRegionName} from "@/utils/functionsRegion";

export default {
  name: "DigitalSignageTVForgotPassword",
  data() {
    return {
      id: null,
      loading: false,
      disable: false,
      email: null,
      timer: 60,
      refreshTimeInterval: null,
      isEmailSent: false
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  created() {
    this.id = this.$route.query.id;
  },
  methods: {
    backToLogin() {
      this.$router.push(`/digital-signage-tv-login/${this.id}`);
    },
    async submit() {
      this.isFormValid = await this.$refs.observer.validate();

      if (!this.isFormValid) return;

      this.loading = true;
      this.disable = true;

      try {
        await firebase.app().functions(getRegionName()).httpsCallable("resetUserPasswordByEmail")({
          email: this.email
        }).then((data) => {
          const response = data;
          if (response.data.data.code === "Failed") {
            this.$toast.open({message: `${response.data.data.message}`, type: "error"});
            this.disable = false;
          } else {
            this.refreshTimeInterval = setInterval(this.updateTimer, 1000);
            this.isEmailSent = true;
          }
        }).catch(function (error) {
          this.$toast.open({message: `${error.message}`, type: "error"});
        });
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    updateTimer() {
      if(this.timer > 0) {
        this.timer = this.timer - 1;
      } else {
        this.disable = false;
      }
    }
  }
}